import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type ClassTemplateToolbarProps = {
  canManage?: boolean;
  onCreate: () => void;
};

export function ClassTemplateToolbar({
  canManage,
  onCreate,
}: ClassTemplateToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="flex items-center font-bold text-2xl tracking-tight">
          Template ຄລາດສ໌
        </h2>
        <p className="text-muted-foreground">
          ຈັດການ template ຄລາດສ໌ໃນລະບົບ.
        </p>
      </div>
      {canManage && (
        <div className="flex items-center space-x-2">
          <Button onClick={onCreate}>
            <PlusIcon className="h-4 w-4" />
            ສ້າງ Template
          </Button>
        </div>
      )}
    </div>
  );
}
